// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA4SgPDgCmqwj8UYDISn8nncKCyK_rf6MM",
    authDomain: "ng-fitness-app-8062a.firebaseapp.com",
    databaseURL: "https://ng-fitness-app-8062a.firebaseio.com",
    projectId: "ng-fitness-app-8062a",
    storageBucket: "ng-fitness-app-8062a.appspot.com",
    messagingSenderId: "625646353106"

  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
